import { render, staticRenderFns } from "./ElixioConnect.vue?vue&type=template&id=0b66842e"
import script from "./ElixioConnect.vue?vue&type=script&lang=js"
export * from "./ElixioConnect.vue?vue&type=script&lang=js"
import style0 from "./ElixioConnect.vue?vue&type=style&index=0&id=0b66842e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports